import { T } from "./translation-keys";
import { JackpotTypes } from "../enums/jackpot";

export const JackpotTypeNames = {
  [JackpotTypes.Mega]: T.MEGA,
  [JackpotTypes.Betshop]: T.BETSHOP,
  [JackpotTypes.Game]: T.GAME,
};
